// @ts-nocheck


import React, { useCallback } from 'react';

import { FilterItem } from '../../../../components';
import Field from '../../../../components/card/Field';
import {
  CommonFilter } from

'../../../../components/hoc/common/handbook/CommonFilter';
import Select from '../../../../components/selects';

const { YearSelect } = Select;





export const BudgetSummaryFilter = (
props) =>
{
  const Filter = useCallback(
    (filterProps) =>
    CommonFilter({ ...filterProps, ...props }),
    [props]
  );
  return (
    <Filter>
      {(values, changeValue) => {
        return (
          <>
            <FilterItem>
              <Field mBottomNone>
                <YearSelect
                  size="small"
                  onChange={(value) => changeValue('year', value)}
                  value={values.year} />

              </Field>
            </FilterItem>
          </>);

      }}
    </Filter>);

};
export default BudgetSummaryFilter;
